import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const ContactDetailLayout = () => {
  const navList = useNav();
  let { contactDetailBottomNav, LeadsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={contactDetailBottomNav} topTabs={LeadsTopHeader} />
      <Outlet />
    </div>
  );
};

export default ContactDetailLayout;
